import _ from 'lodash'

import {
    BUSINESS_PARTNERS_TABLE_CHANGE,
    BUSINESS_PARTNERS_TABLE_CHANGE_REQUEST,
    BUSINESS_PARTNERS_TABLE_LOADING_TRUE,
    BUSINESS_PARTNERS_TABLE_DATA_RECEIVED,
    BUSINESS_PARTNERS_TABLE_LOADING_FALSE,
} from './constants'

import config from '../../../../../../../../../config'

export function businessPartnersTableChange(module, blockKey, id, level, customData, queryParams) {
    return {
        type: BUSINESS_PARTNERS_TABLE_CHANGE,
        data: {
            module,
            blockKey,
            id,
            level,
            customData,
            queryParams,
        },
    }
}

export function businessPartnersTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: BUSINESS_PARTNERS_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.${module}.${blockKey}.block[1].uri`),
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function businessPartnersTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: BUSINESS_PARTNERS_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function businessPartnersTableDataReceived(module, id, blockKey, customData) {
    return {
        type: BUSINESS_PARTNERS_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function businessPartnersTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: BUSINESS_PARTNERS_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
